import moment from 'moment';
import fileSaver from 'file-saver';

import axios from '../../../utils/axios';
import { queryStringBuilder } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';
import {
  DOWNLOAD_CLINICIAN_PLAN,
  DOWNLOAD_CLINICIAN_PLAN_FAILURE,
  DOWNLOAD_CLINICIAN_PLAN_SUCCESS,
} from '../../constants/types';

const locale = globals.getArea('dailyPlanning');

const startDownload = () => ({
  type: DOWNLOAD_CLINICIAN_PLAN,
});

const errorDownload = error => ({
  type: DOWNLOAD_CLINICIAN_PLAN_FAILURE,
  error,
});

const successDownload = () => ({
  type: DOWNLOAD_CLINICIAN_PLAN_SUCCESS,
});

export const downloadPlan = (clinicianId, reportDate, auth, name) => async dispatch => {
  const date = moment(reportDate).format(globals.dateFormats.date);
  const isAuthObject = typeof auth === 'object' && auth !== null;
  const parameters = {
    clinicianId,
    date,
  };
  const token = `Bearer ${isAuthObject ? auth.jwtToken : auth}`;

  dispatch(startDownload());

  try {
    const response = await axios({
      url: `v1/query/GenerateClinicianPlan${queryStringBuilder(parameters)}&tid=${auth.tid}`,
      responseType: 'blob',
      headers: {
        Authorization: token,
      },
    });

    fileSaver.saveAs(
      response.data,
      `${locale.getMsg('planForClinician', [name.replace(/([^a-z0-9 ]+)/gi, ''), date])}.pdf`,
    );
    dispatch(successDownload());
  } catch (error) {
    dispatch(errorDownload(error));
  }
};
